import { initialUpperCase } from '../components/FilterCommon/utils';

// 合并相同关键词
export const mergeSameKeyword = (kys, langId) => {
  let allKeywordIndexMap = new Map(); // 所有词的名称和下标
  for (let i = 0; i < kys.length; i++) {
    const tk = kys[i];
    if (langId === 1) {
      if (allKeywordIndexMap.has(tk?.keyword_en)) {
        allKeywordIndexMap.set(tk?.keyword_en, [
          ...allKeywordIndexMap.get(tk?.keyword_en),
          i,
        ]);
      } else {
        allKeywordIndexMap.set(tk?.keyword_en, [i]);
      }
    } else {
      if (allKeywordIndexMap.has(tk?.keyword_cn)) {
        allKeywordIndexMap.set(tk?.keyword_cn, [
          ...allKeywordIndexMap.get(tk?.keyword_cn),
          i,
        ]);
      } else {
        allKeywordIndexMap.set(tk?.keyword_cn, [i]);
      }
    }
  }
  // 找出下标数组长度大于1的，说明这个词是重复的
  let mergedKeywords: any[] = []; // 相同关键词合并之后的词组
  let sameKeywordIndexs: number[] = []; // 相同关键词的下标
  for (let [key, value] of allKeywordIndexMap) {
    if (value?.length > 1) {
      sameKeywordIndexs = [...sameKeywordIndexs, ...value];
      let mergedCount = 0;
      let mergedCommentsCount = 0;
      let mergedSocialCount = 0;
      let mergedKeyword: string[] = [];
      let mergedKeywordCn: string[] = [];
      let mergedKeywordEn: string[] = [];
      let mergedChild: any[] = [];
      for (const idx of value) {
        mergedCount += kys[idx]?.count;
        mergedCommentsCount += kys[idx]?.count_comments;
        mergedSocialCount += kys[idx]?.count_social;
        mergedKeyword = [...mergedKeyword, kys[idx]?.keyword];
        mergedKeywordCn = [...mergedKeywordCn, kys[idx]?.keyword_cn];
        mergedKeywordEn = [...mergedKeywordEn, kys[idx]?.keyword_en];
        mergedChild = kys[idx]?.child
          ? [...mergedChild, ...kys[idx]?.child]
          : [...mergedChild];
      }
      mergedKeywords.push(
        Object.assign(kys[value[0]], {
          mergedCount,
          mergedCommentsCount,
          mergedSocialCount,
          mergedKeyword,
          mergedKeywordCn,
          mergedKeywordEn,
          mergedChild,
        }),
      );
    }
  }
  // 从后往前删除所有重复的关键词
  for (const idx of sameKeywordIndexs.sort((x, y) => y - x)) {
    kys?.splice(idx, 1);
  }
  // 加入合并之后的关键词，按声量倒序
  kys = [...kys, ...mergedKeywords];
  kys.sort((a, b) => {
    if (a?.mergedCount) {
      return b?.count - a?.mergedCount;
    } else if (b?.mergedCount) {
      return b?.mergedCount - a?.count;
    } else {
      return b?.count - a?.count;
    }
  });

  return kys;
};

export const copyAndDuplicateKeyword = (...list) => {
  return list.map((item) => {
    try {
      let newItem = JSON.parse(JSON.stringify(item));
      newItem = newItem.map((i) => i.toLowerCase()).map(initialUpperCase);
      return Array.from(new Set(newItem));
    } catch (error) {
      return item;
    }
  });
};
